module.exports = "<svg id=\"e671e65f-8347-4ab2-a8dc-5e24c9e70195\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>phone</title><path d=\"M15.21,31.1,7.07,41.41a.55.55,0,0,0,.09.76h0l6.21,5a6.07,6.07,0,0,0,4.44,1.3c1.54-.16,12-12.75,15.32-18.48a122.49,122.49,0,0,0,8.48-17.88,6.09,6.09,0,0,0-3.49-7.82L30.71,1.38a.55.55,0,0,0-.71.31h0L25.13,13.92a.55.55,0,0,0,.31.71h0l4.15,1.62c-1.4,3-3,6-4.67,9l0,0c-1.69,2.93-3.52,5.79-5.43,8.51L16,31a.55.55,0,0,0-.77.08l0,0ZM30.83,16.18h0Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Phone.svg
// module id = 500
// module chunks = 1